// 주소 확정 전용: axios timeout만으로는 인증 interceptor 대기까지 제한할 수 없다.
// Abort signal also fences a queued interceptor retry after the deadline.
export async function withAddressConfirmationDeadline(request, timeout = 10000) {
  const controller = new AbortController();
  let timer;
  const deadline = new Promise((resolve, reject) => {
    timer = setTimeout(() => {
      controller.abort();
      reject(Object.assign(new Error("Address confirmation deadline"), { code: "ECONNABORTED" }));
    }, timeout);
  });
  try {
    return await Promise.race([request({ timeout, signal: controller.signal }), deadline]);
  } finally {
    clearTimeout(timer);
  }
}
